import { useShowLibrary } from '@customer/hooks/assets/useShowLibrary';
import { AssetModel, TechLibraryDocumentFilterModel } from '@customer/store/apis/assetsApi';
import { VdsButton, VdsIcon } from '@volt/volt-extended-components-react';
import { CustomCellRendererProps } from 'ag-grid-react';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { EmptyCell } from '../../formatters/genericFormatters';

export function OpenInLibraryLinkRenderer({
  value,
}: CustomCellRendererProps<AssetModel, TechLibraryDocumentFilterModel>): ReactElement | string {
  const { t } = useTranslation();

  const onShowLibrary = useShowLibrary(value);

  if (value) {
    return (
      <VdsButton size="small" variant="ghost" onClick={onShowLibrary}>
        {t('OpenInLibrary')}
        <VdsIcon slot="icon-right" svgIcon="open-icon" />
      </VdsButton>
    );
  }

  return EmptyCell;
}

export default OpenInLibraryLinkRenderer;
